<template>
  <div>
    <CardedForm
      ref="cities_form_ref"
      id="cities_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="form.name"
        :validation_rules="form_validations.name"
        label="Name Of City"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="form.short_name"
        :validation_rules="form_validations.short_name"
        label="City Short name"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>

      <SelectField
        v-model="form.district_id"
        :options="districts"
        :small_chips="false"
        :validation_rules="form_validations.district_id"
        label="District"
        icon="mdi-pen-plus"
        :disabled="is_loading"
        :is_loading_info="is_loading_info"
        :item_text="'name'"
        :item_value="'id'"
      ></SelectField>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminCitiesAdd",
  components: {
    CardedForm,
    TextField,
    SelectField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        name: "",
        short_name: "",
        district_id: null,
      },
      form_validations: {
        name: [
          Utils.validate.is_required("City name is required"),
          Utils.validate.min_max_length(
            2,
            30,
            "City name should be between 2 and 30 characters "
          ),
        ],
        short_name: [
          Utils.validate.max_length(
            20,
            "Short City name should be less than 20 characters "
          ),
        ],
        district_id: [Utils.validate.is_required("Please select a district")],
      },
      edit_city_id: 0,
      districts: [],
      is_loading_info: false
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
      var rnd = Math.ceil(Math.random() * 999);
      this.form.name = "city_name_" + rnd;
      this.form.short_name = "short_city_name_" + rnd;
      this.form.district_id = 1;
    },
    init_form() {
      this.form.name = "";
      this.form.short_name = "";
      this.form.district_id = null;
      this.errors = [];
      this.message = "";
      this.$refs.cities_form_ref.on_clear_form();
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      if (this.is_editing == true) {
        ServerClient.Locations.update_city(
          {
            id: this.edit_city_id,
            ...this.form,
          },
          (res) => {
            console.log("edit cities res", res);
            this.$emit("on-hide-loader");
            this.message =
              "<b>Edit Was Successfull</b> <br/>  City has been edited";
            this.$refs.cities_form_ref.show_message_dialog();
          },
          (errors) => {
            console.log("edit cities errors", errors);
            this.errors = errors;
            this.$refs.cities_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
          }
        );
      } else {
        ServerClient.Locations.post_city(
          this.form,
          (res) => {
            console.log("add cities res", res);
            this.$emit("on-hide-loader");
            this.message =
              "<b>Operation Was Successfull</b> <br/>  City was added";
            this.$refs.cities_form_ref.show_message_dialog();
          },
          (errors) => {
            console.log("add cities errors", errors);
            this.errors = errors;
            this.$refs.cities_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
          }
        );
      }
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
    fill_edit_city(city) {
      console.log("city to be edited ", city);
      this.edit_city_id = city.id;
      this.form.short_name = city.short_name;
      this.form.name = city.name;
      this.form.district_id = parseInt(city.district_id);
      this.errors = [];
      this.message = "";
    },
    load_districts() {
      this.is_loading_info = true;
      ServerClient.Locations.get_districts(
        {
          is_drop_down: true,
        },
        (res) => {
          this.districts = res;
          this.is_loading_info = false;
        },
        (errors) => {
          this.is_loading_info = false;
          console.log("Errors loading districts on add city");
        }
      );
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add A City",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "New City",
          disabled: true,
          href: "/admin/locations/cities/add",
        },
      ],
    });
    this.init_form();
    this.load_districts();
  },
};
</script>